<template>
  <div>
    <div class="mb-1"><b>Service Category</b></div>
    <Select
      v-model="serviceCategoryId"
      :options="serviceCategories"
      search
      :name="fieldName"
      no-label
      :field-error="
        v$.$errors.find(({ $property }) => $property === 'serviceCategoryId')
          ?.$message
      "
      full-width
      data-cy="service-category-select"
    ></Select>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";
export default {
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue"],
  validations() {
    return {
      serviceCategoryId: {
        requiredIf: requiredIf(this.required),
        $autoDirty: true
      }
    };
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      fieldName: "Service Category"
    };
  },
  computed: {
    ...mapState({
      serviceCategories({ serviceCategories }) {
        return serviceCategories
          .filter((sc) => sc.id === this.modelValue || !sc.archived)
          .map((sc) => ({
            ...sc,
            label: sc.name,
            value: sc.id
          }));
      }
    }),
    serviceCategoryId: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  mounted() {
    if (!this.serviceCategories.length) {
      this.fetchServiceCategories();
    }
  },
  methods: {
    ...mapActions(["fetchServiceCategories"]),
    async validate() {
      return await this.v$.$validate();
    }
  }
};
</script>

<style lang="scss" scoped></style>
